export const API_URL = process.env.REACT_APP_API_URL + "/api/req-data/";// || "http://localhost:8000/api/req-data/";